import { render, staticRenderFns } from "./header-main-menu-submenu.vue?vue&type=template&id=078db736&scoped=true&"
import script from "./header-main-menu-submenu.vue?vue&type=script&lang=js&"
export * from "./header-main-menu-submenu.vue?vue&type=script&lang=js&"
import style0 from "./header-main-menu-submenu.vue?vue&type=style&index=0&id=078db736&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078db736",
  null
  
)

export default component.exports